
<div class="modal-header">
    <h4 class="modal-title">Cloud-based Services Terms & Conditions</h4>
</div>
<div class="modal-body">
    
    <div class="terms-body">
      <h5>ELIWELL AIR WEB APPLICATION</h5>
        <p>Please read and accept our Terms & Conditions and Privacy Policy, you can find at the following links.</p>

        <p><a class="anchorempty" href="terms"  rel="noopener noreferrer"  target="_blank">Terms & Condition</a> </p>
        <p><a class="anchorempty" href="terms"  rel="noopener noreferrer"  target="_blank">Privacy Policy</a> </p>
              
    </div>
    <label for="termsandcondition">
    <input type="checkbox" [(ngModel)]="termsandcondition" id="termsandcondition" />
    I agree with the Terms & Conditions.
  </label>
    <br>
    <label for="privacyandpolicy">
    <input type="checkbox" [(ngModel)]="privacyandpolicy" id="privacypolicy" />
    I agree with the Privacy Policy.
  </label>
</div>
<div class="modal-footer text-center">
    <button type="button" [disabled]="!termsandcondition || !privacyandpolicy" class="btn btn-accept" (click)="AcceptTerms()">I Agree</button>
    <button type="button" class="btn btn-accept" (click)="DeclineTerms()">{{labels.decline}}</button>
</div>
